import { env } from '@/env';

/** O ImpostoCerto, onde fica o Módulo de Recebimento. */
const IMPOSTOCERTO_PADRAO = 'https://app.impostocerto.com.br';

/**
 * O endereço da caixa de entrada do Recebimento na mesma empresa e no mesmo período (SPEC-018, §3, item 8).
 * A caixa aceita esses filtros pelo endereço (`contribuinte`, `emissaoDe`, `emissaoAte`); com mais de uma
 * empresa escolhida, vai sem empresa.
 */
export function linkDaCaixaDeEntrada(params: {
  cnpjs: string | null | undefined;
  dataInicio: string | null | undefined;
  dataFim: string | null | undefined;
  base?: string;
}): string {
  const base = (params.base || env.VITE_IMPOSTOCERTO_APP_URL || IMPOSTOCERTO_PADRAO).replace(
    /\/+$/,
    ''
  );
  const busca = new URLSearchParams();
  const cnpjs = (params.cnpjs ?? '')
    .split(',')
    .map(cnpj => cnpj.replace(/\D/g, ''))
    .filter(Boolean);
  if (cnpjs.length === 1) busca.set('contribuinte', cnpjs[0]);
  if (params.dataInicio) busca.set('emissaoDe', params.dataInicio.slice(0, 10));
  if (params.dataFim) busca.set('emissaoAte', params.dataFim.slice(0, 10));
  const consulta = busca.toString();
  return `${base}/recebimento/caixa-de-entrada${consulta ? `?${consulta}` : ''}`;
}
